import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_URL = "/api";

function Dashboard() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      window.location.href = "/";
      return;
    }

    try {
      const response = await axios.get(
        `${API_URL}/users/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setUsers(response.data);
    } catch (error) {
      console.error(error.response || error);

      localStorage.removeItem("token");
      window.location.href = "/";
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return (
    <div style={{ padding: "40px" }}>
      <h1>Dashboard</h1>

      {loading ? (
        <p>Cargando información...</p>
      ) : (
        <p>
          Usuarios cargados: <strong>{users.length}</strong>
        </p>
      )}
    </div>
  );
}

export default Dashboard;